<template>
  <vuex-table :fields="fields" table_store="autoinformer/stats/details/table">
    <template slot="state" slot-scope="{ item }">
      {{ $t(`autoinformer.stats.state.${item.state}`) }}
    </template>
  </vuex-table>
</template>

<script>
  import { seconds_to_time } from '@shared/helpers/time';

  export default {
    computed: {
      fields() {
        return [
          {
            key: 'name',
            label: this.$t('autoinformer.stats.table.field.campaign'),
            sortable: false
          },
          {
            key: 'dst',
            label: this.$t('autoinformer.stats.table.field.task_number'),
            sortable: false
          },
          {
            key: 'src',
            label: this.$t('autoinformer.stats.table.field.src'),
            sortable: true
          },
          {
            key: 'state',
            label: this.$t('shared.component.table.field.status'),
            sortable: true
          },
          {
            key: 'call_date',
            label: this.$t('autoinformer.stats.table.field.date_time'),
            sortable: true,
            thStyle: { width: '200px' }
          },
          {
            key: 'duration_billed',
            label: this.$t('autoinformer.stats.table.field.duration'),
            formatter: value => seconds_to_time(value),
            sortable: true
          },
          {
            key: 'keys',
            label: this.$t('autoinformer.stats.table.field.client_action'),
            sortable: true
          }
        ];
      }
    }
  };
</script>
